// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
/* tslint:disable */
/* eslint-disable */
import "../textstyles/fonts.css";
import "../reset.css";
import "./BackdropLight.css";
import React, { createContext, useContext } from "react";
import {
  findSetVariantProps,
  makeCompositeDefaultProps,
} from "../_internal_utils";
import { RootPrimitive, ContainerPrimitive } from "../_internal_primitives";

const styles = [
  {
    type: "default",
    layers: {},
  },
  {
    type: "enum",
    propName: "size",
    values: [
      {
        propValue: "large850",
        layers: {},
      },
      {
        propValue: "med450",
        layers: {},
      },
      {
        propValue: "small",
        layers: {},
      },
    ],
  },
  {
    type: "boolean",
    propName: "gone",
    layers: {},
  },
];

const defaultPropValues = [
  {
    type: "default",
    layers: {},
  },
  {
    type: "enum",
    propName: "size",
    values: [
      {
        propValue: "large850",
        layers: {},
      },
      {
        propValue: "med450",
        layers: {},
      },
      {
        propValue: "small",
        layers: {},
      },
    ],
  },
  {
    type: "boolean",
    propName: "gone",
    layers: {},
  },
];

const variantPropTypes = [
  {
    type: "enum",
    propName: "size",
    propValues: ["large850", "med450", "small"],
  },
  {
    type: "boolean",
    propName: "gone",
  },
];

export const BackdropLightContext = createContext(null);

function BackdropLight(_props) {
  const defaults = useContext(BackdropLightContext);
  const props = { ...defaults, ..._props };
  const activeVariants = findSetVariantProps(variantPropTypes, props);
  const getCompositeDefaultProps = makeCompositeDefaultProps(
    defaultPropValues,
    activeVariants
  );
  return (
    <RootPrimitive
      {...props}
      key="U8EBjWxuNf"
      addSpacing={false}
      internal={{
        projectId: "7X7HTLRqyD",
        styles: styles,
        layerId: "U8EBjWxuNf",
        scope: "LwaKtrXgPE",
        activeVariants: activeVariants,
      }}
    >
      <ContainerPrimitive
        key={"X4zCryy62b"}
        id={"Slot_X4zCryy62b"}
        className={
          "__visly_reset_7X7HTLRqyD __visly_scope_LwaKtrXgPE_X4zCryy62b"
        }
        addSpacing={false}
      >
        {props.children}
      </ContainerPrimitive>
    </RootPrimitive>
  );
}

BackdropLight.__variants = [
  {
    name: "size",
    type: "group",
    variants: ["large850", "med450", "small"],
  },
  {
    name: "gone",
    type: "variant",
  },
];

export default BackdropLight;
